import { getBlogFeed } from "../api/content";
import { SearchExperience } from "../components/search/SearchExperience";

/**
 * The Journal. Built on the shared faceted-search experience, pointed at the
 * blog-feed endpoint — which surfaces journal entries, films, documents, and
 * external links/articles (everything except standalone photographs), all
 * searchable, filterable, and sortable.
 */
export function BlogPage() {
  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Field notes · Index BL</p>
          <h1 className="page__title">Journal</h1>
          <p className="page__intro">
            Trip reports, dive logs, videos, and links worth keeping — search the
            full index, filter by type or tag, and sort to taste. Entries open in
            full; references open at the source.
          </p>
        </header>

        <SearchExperience
          fetcher={getBlogFeed}
          placeholder="Search journal entries, videos, documents, links…"
          emptyLabel="No journal entries match those filters yet."
        />
      </div>
    </div>
  );
}
